<template>
  <div class="challenges-page">

    <challenges-hero-section
      :fields="challengesPageSections.sections.challenges_hero_section.fields"
    />

    <challenges-divider-section
      :fields="challengesPageSections.sections.challenges_divider_section.fields"
    />

    <challenges-cover-section
      :fields="challengesPageSections.sections.challenges_cover_section.fields"
    />

    <challenges-text-section
      :fields="challengesPageSections.sections.challenges_text_section.fields"
    />

    <challenges-divider2-section
      :fields="challengesPageSections.sections.challenges_divider2_section.fields"
    />

    <challenges-features-section
      :fields="challengesPageSections.sections.challenges_features_section.fields"
    />


    <challenges-divider3-section
      :fields="challengesPageSections.sections.challenges_divider3_section.fields"
    />

    <challenges-text2-section
      :fields="challengesPageSections.sections.challenges_text_2_section.fields"
    />

    <challenges-call-to-action-section
      :fields="challengesPageSections.sections.challenges_call_to_action_section.fields"
    />


  </div>
</template>

<script>
import DividerSection from "/seu-frontend/sections/general/DividerSection";
import ChallengesHeroSection from "/seu-frontend/sections/challenges-page/ChallengesHeroSection";
import ChallengesCoverSection from "/seu-frontend/sections/challenges-page/ChallengesCoverSection";
import ChallengesTextSection from "/seu-frontend/sections/challenges-page/ChallengesTextSection";
import ChallengesText2Section from "/seu-frontend/sections/challenges-page/ChallengesText2Section";
import ChallengesAccordionSection from "/seu-frontend/sections/challenges-page/ChallengesAccordionSection";
import ChallengesCallToActionSection from "/seu-frontend/sections/challenges-page/ChallengesCallToActionSection";
import ChallengesFeaturesSection from "/seu-frontend/sections/challenges-page/ChallengesFeaturesSection";
import ChallengesDividerSection from "/seu-frontend/sections/challenges-page/ChallengesDividerSection";
import ChallengesDivider2Section from "/seu-frontend/sections/challenges-page/ChallengesDivider2Section";
import ChallengesDivider3Section from "/seu-frontend/sections/challenges-page/ChallengesDivider3Section";


export default {
  name: "ChallengesPage",
  components: {
    ChallengesDivider3Section,
    ChallengesDivider2Section,
    ChallengesDividerSection,
    ChallengesFeaturesSection,
    ChallengesCallToActionSection,
    ChallengesAccordionSection,
    ChallengesText2Section,
    ChallengesTextSection,
    ChallengesCoverSection,
    ChallengesHeroSection,
    DividerSection,
  },

  data: () => ({
    buttonIcon: require('../assets/icons/arrow-white-right.svg'),
  }),

  computed: {
    challengesPageSections() {
      return require(`../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/challengesPage`).default;
    }
  },

  metaInfo() {
    return {
      title: this.challengesPageSections.title,
    }
  }

}
</script>

<style lang="scss">
@import "ChallengesPage";
</style>
